import {
    SESSION_CREATE,
    SESSION_UPDATE,
    SESSION_MERGE_IN,
    SESSION_INVALIDATE
} from './types'

export function sessionCreate(payload) {
    return {
        type: SESSION_CREATE,
        payload
    }
}

export function sessionUpdate(payload) {
    return {
        type: SESSION_UPDATE,
        payload
    }
}

export function sessionMergeIn(path, data) {
    return {
        type: SESSION_MERGE_IN,
        payload: { path, data }
    }
}

export function sessionInvalidate() {
    return {
        type: SESSION_INVALIDATE
    }
}
